import { render, staticRenderFns } from "./BoxPeriodico.vue?vue&type=template&id=0ca5f0ec&scoped=true"
import script from "./BoxPeriodico.vue?vue&type=script&lang=js"
export * from "./BoxPeriodico.vue?vue&type=script&lang=js"
import style0 from "./BoxPeriodico.vue?vue&type=style&index=0&id=0ca5f0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5f0ec",
  null
  
)

export default component.exports